import { NotificationResponseDto } from '../../helper-types/dtos/notification/responses/notification-response-dto';
import { API_RELATIVE_URI } from '../../helper-types/general/consts/api-relative-uri';
import { ApiResponse } from '../../helper-types/general/custom-types/api-response';
import HTTP_CLIENT from '../common/http-client-wrapper';

export class NotificationService {
    private readonly _httpClient: typeof HTTP_CLIENT;

    constructor(httpClient: typeof HTTP_CLIENT) {
        this._httpClient = httpClient;
    }

    async getMyNotificationsAsync(): Promise<ApiResponse<NotificationResponseDto[]>> {
        return await this._httpClient.getFromJsonAsync<ApiResponse<NotificationResponseDto[]>>(
            API_RELATIVE_URI.NOTIFICATIONS_MINE
        );
    }

    async getUnreadCountAsync(): Promise<ApiResponse<number>> {
        return await this._httpClient.getFromJsonAsync<ApiResponse<number>>(
            API_RELATIVE_URI.NOTIFICATIONS_UNREAD_COUNT
        );
    }

    async markAsReadAsync(notificationId: number): Promise<ApiResponse<object>> {
        return await this._httpClient.putAsJsonAsync<null, ApiResponse<object>>(
            `${API_RELATIVE_URI.NOTIFICATIONS_MARK_READ}?notificationId=${notificationId}`,
            null
        );
    }

    async markAllAsReadAsync(): Promise<ApiResponse<object>> {
        return await this._httpClient.putAsJsonAsync<null, ApiResponse<object>>(
            API_RELATIVE_URI.NOTIFICATIONS_MARK_ALL_READ,
            null
        );
    }
}

// Export a singleton instance
export const NOTIFICATION_SERVICE = new NotificationService(HTTP_CLIENT);
